import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Component pages
import { CalendarComponent } from './calendar/calendar.component';
import { FileManagerComponent } from "./file-manager/file-manager.component";

const routes: Routes = [
  {
    path: "calendar",
    component: CalendarComponent
  },
  {
    path: "file-manager",
    component: FileManagerComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AppsRoutingModule { }
